export default "__VITE_ASSET__BTTvTcth__"